import { createContext } from "react"

const DashboardLayoutContext = createContext(false)

export const DashboardLayoutProvider = DashboardLayoutContext.Provider

export default DashboardLayoutContext